import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { BeaconToggleButtonField } from '@trp-beacon-ui-kit/foundation/components/beacon-toggle-button-field';
import { BeaconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-button';
import { BeaconInputField } from '@trp-beacon-ui-kit/foundation/components/beacon-input-field';
import { BeaconRadioGroup } from '@trp-beacon-ui-kit/foundation/components/beacon-radio-group';
import { BeaconRadioButton } from '@trp-beacon-ui-kit/foundation/components/beacon-radio-button';
import { BeaconCheckbox } from '@trp-beacon-ui-kit/foundation/components/beacon-checkbox';
import { BeaconDropdown } from '@trp-beacon-ui-kit/foundation/components/beacon-dropdown';
import { BeaconErrorMessageSummary } from '@trp-beacon-ui-kit/foundation/components/beacon-error-message-summary';
import { BeaconIconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-icon-button';
import { BeaconDatePicker } from '@trp-beacon-ui-kit/foundation/components/beacon-date-picker';
import { BeaconModal } from '@trp-beacon-ui-kit/foundation/components/beacon-modal';
import { BeaconError } from '@trp-beacon-ui-kit/foundation/components/beacon-error';
const PROJECT_NAME = 'ssj';

// Prefix value to remove conflict with other component
const projectNamePrefix = `${PROJECT_NAME}`;

// Registered Beacon Components
export const SSJBeaconToggleButtonField = registerReactComponent(
  projectNamePrefix,
  BeaconToggleButtonField
);

export const SSJBeaconInputField = registerReactComponent(
  projectNamePrefix,
  BeaconInputField
);

export const SSJBeaconButton = registerReactComponent(
  projectNamePrefix,
  BeaconButton
);

export const SSJBeaconRadioGroup = registerReactComponent(
  projectNamePrefix,
  BeaconRadioGroup
);

export const SSJBeaconRadioButton = registerReactComponent(
  projectNamePrefix,
  BeaconRadioButton
);

export const SSJBeaconCheckbox = registerReactComponent(
  projectNamePrefix,
  BeaconCheckbox
);

export const SSJBeaconDropdown = registerReactComponent(
  projectNamePrefix,
  BeaconDropdown
);

export const SSJBeaconIconButton = registerReactComponent(
  projectNamePrefix,
  BeaconIconButton
);

export const SSJBeaconErrorMessageSummary = registerReactComponent(
  projectNamePrefix,
  BeaconErrorMessageSummary
);

export const SSJBeaconDatePicker = registerReactComponent(
  projectNamePrefix,
  BeaconDatePicker
);

export const SSJBeaconModal = registerReactComponent(
  projectNamePrefix,
  BeaconModal
);

export const SSJBeaconError = registerReactComponent(
  projectNamePrefix,
  BeaconError
);
//'@trp-beacon-ui-kit/foundation/react';
const Registry = {
  SSJBeaconIconButton,
  SSJBeaconErrorMessageSummary,
  projectNamePrefix,
  SSJBeaconToggleButtonField,
  SSJBeaconButton,
  SSJBeaconInputField,
  SSJBeaconRadioGroup,
  SSJBeaconRadioButton,
  SSJBeaconCheckbox,
  SSJBeaconDropdown,
  SSJBeaconDatePicker,
  SSJBeaconModal,
  SSJBeaconError,
};

export default Registry;
